/** Root application route. */
export const ROUTE_ROOT = '/';

/** Authentication routes. */
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_SUCCESS = '/login-success';

/** Workspace routes. */
export const WORKSPACE_OPERATIONAL = '/operational';
export const CANVAS_ROUTE_PREFIX = `${WORKSPACE_OPERATIONAL}/canvas`;

/** Default post-login landing canvas ukey when product line omits `landingCanvasUkey`. */
export const DEFAULT_LANDING_CANVAS_UKEY = 'daxl-product-data-management';

/** Default post-login and root fallback route. */
export const DEFAULT_LANDING_PATH = `${CANVAS_ROUTE_PREFIX}/${DEFAULT_LANDING_CANVAS_UKEY}`;

/** Build a host-level canvas route for the given canvas/module ukey. */
export function buildCanvasRoute(canvasUkey: string): string {
  return `${CANVAS_ROUTE_PREFIX}/${canvasUkey}`;
}
